import { combineReducers } from 'redux';
import makeModelReducers from '../../../oldpantheon/redux/creators/models/makeModelReducers';

const reducers = makeModelReducers({ model: `horoscope` });

export default combineReducers(reducers);
